import { RouteModel } from '@/modules/navigation/models/route.model';
import Router from '@/router';

export class Section {
  route: RouteModel;

  name: string;

  key: string;

  sectionProgress!: number | undefined;

  isActive: boolean;

  isEnabled: boolean;

  isLocked: boolean;

  isCompleted: boolean;

  isSkipped: boolean;

  wasReached: boolean;

  lockPreviousRoutes: boolean;

  isBackButtonDisabled = false;

  isNextButtonDisabled = false;

  isNavigationHidden = false;

  isStepsHidden = false;

  isNavDrawerDisabled = false;

  skipRoute: boolean | string = false;

  declare parentSection?: any;

  constructor(route: RouteModel, private $router: typeof Router, parentSection?: Section) {
    this.route = route;

    this.name = route.routeName;
    this.key = route.key;
    this.isActive = route.active || !!route.isExpanded;
    this.isEnabled = route.enabled;
    this.lockPreviousRoutes = route.header?.navBar?.lockPreviousRoutes;
    this.isLocked = false;
    this.isCompleted = false;
    this.isSkipped = false;
    this.wasReached = false;
    this.isBackButtonDisabled = route.header?.navBar?.disableBackButton;
    this.isNextButtonDisabled = route.header?.navBar?.disableNextButton;
    this.isNavigationHidden = route.isNavigationHidden;
    this.isStepsHidden = route.isStepsHidden;
    this.isNavDrawerDisabled = route.isNavDrawerDisabled;
    this.skipRoute = route.skipRoute;

    this.parentSection = parentSection;
  }

  navigate() {
    return this.$router.replace({ name: this.name });
  }

  setSectionProgress(newProgress: number) {
    this.sectionProgress = newProgress;
  }
}
